import React from "react";

export default class Tabs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: 0,
    };
  }

  changeTab(tabIndex) {
    this.setState({ selectedTab: tabIndex });
    this.props.onChangeTab && this.props.onChangeTab(tabIndex);
  }

  render() {
    const { errorTabs, className } = this.props;

    return (
      <div className="tabs-container">
        <div className="tabs">
          <div className="tabs-scroll">
            {this.props.tabsData.map((tab, index) => (
              <div
                key={index}
                className={`tab ${index === this.state.selectedTab && "selected"}`}
                onClick={() => this.changeTab(index)}
              >
                {tab.name}
                {errorTabs &&
                  errorTabs.find((el) => el === index) !== undefined && (
                    <span style={{ color: "red", marginLeft: 4 }}>&bull;</span>
                  )}
              </div>
            ))}
          </div>
          <div className="tabs-border"/>
      </div>
        <div className={`tab-page ${className} ${this.props.tabsData[this.state.selectedTab].className}`}>
          <div className="tab-page-content">
            {this.props.tabsData[this.state.selectedTab].renderedComponent}
          </div>
        </div>
      </div>
    );
  }
}
